import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Tooltip} from 'antd';
import {
  StyledInvoiceDocumentCard,
  StyledInvoiceDocumentCardPreview,
  StyledInvoiceDocumentCardButton
} from './StyledInvoiceDocumentCard';
import {ChevronLeftIcon, ChevronRightIcon} from '../../../../icons';
import {invoicesHelpers} from '../../../../utils/helpers';

const getInvoiceDetailsLink = invoicesHelpers.getInvoiceDetailsLink;

const InvoiceDocumentCard = ({
  edit = true,
  invoice,
  neighborIds,
  ...rest
}) => {
  const [t] = useTranslation('main');

  const previousButtonProps = useMemo(
    () => ({ disabled: !Boolean(neighborIds.prev) }),
    [neighborIds]
  );

  const nextButtonProps = useMemo(
    () => ({ disabled: !Boolean(neighborIds.next) }),
    [neighborIds]
  );

  const attachment = {
    file: invoice?.file_url,
    name: invoice?.file_name
  }

  return (
    <StyledInvoiceDocumentCard size={4} {...rest}>
      <Tooltip title={t('previous')}>
        <Link to={getInvoiceDetailsLink(neighborIds.prev)} {...previousButtonProps}>
          <StyledInvoiceDocumentCardButton type='text' icon={<ChevronLeftIcon />} {...previousButtonProps} />
        </Link>
      </Tooltip>
      <StyledInvoiceDocumentCardPreview attachment={attachment} multiple={true} showFullscreenButton={false} />
      <Tooltip title={t('next')}>
        <Link to={getInvoiceDetailsLink(neighborIds.next)} {...nextButtonProps}>
          <StyledInvoiceDocumentCardButton type='text' icon={<ChevronRightIcon />} {...nextButtonProps} />
        </Link>
      </Tooltip>
    </StyledInvoiceDocumentCard>
  );
}

InvoiceDocumentCard.propTypes = {
  edit: PropTypes.bool,
  invoice: PropTypes.shape({
    id: PropTypes.string,
    file_name: PropTypes.string,
    file_url: PropTypes.string,
  }),
  neighborIds: PropTypes.shape({
    next: PropTypes.string,
    prev: PropTypes.string
  }),
}

export default InvoiceDocumentCard;

